// // --- Shipping Protection Add-on Script (Live Sync) --- //

// // CONFIGURATION
// const addonProductHandle = 'shipping-insurance'; // Replace with your add-on product handle
// let userOptedOut = false; // remembers if user turned it off manually
// let lastCheckboxState = false;


// // 🧩 GET ADD-ON VARIANT
// async function getVariantIdByHandle(handle) {
//   const res = await fetch(`/products/${handle}.js`);
//   if (!res.ok) throw new Error(`Product not found: ${handle}`);
//   const product = await res.json();
//   return product.variants[0].id;
// }

// // ➕ ADD ADD-ON (max qty = 1)
// async function addAddon(variantId) {
//   const cart = await fetch('/cart.js').then(r => r.json());
//   const variantIdNew = await getVariantIdByHandle(addonProductHandle);
//   const existingItem = cart.items.find(i => i.variant_id === variantIdNew);

//   // 🚫 Already exists → ensure quantity = 1
//   if (existingItem) {
//     if (existingItem.quantity > 1) {
//       await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: existingItem.key, quantity: 1 })
//       });
//     }
//     await syncCheckboxState(true);
//     await refreshCartDrawer();
//     return;
//   }

//   // ✅ Add new (only once)
//   await fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ id: variantId, quantity: 1 })
//   });

//   await syncCheckboxState(true);
//   await refreshCartDrawer();
// }

// // ➖ REMOVE ADD-ON
// async function removeAddon(variantId) {
//   const cart = await fetch('/cart.js').then(r => r.json());
//   const item = cart.items.find(i => i.variant_id === variantId);
//   if (!item) return;

//   await fetch('/cart/change.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ id: item.key, quantity: 0 })
//   });

//   const updatedCart = await fetch('/cart.js').then(r => r.json());

//   // 🧹 Rule 4: If only add-on remains, remove it automatically
//   if (updatedCart.item_count === 1 && updatedCart.items[0].variant_id === variantId) {
//     await fetch('/cart/clear.js', { method: 'POST' });
//     await refreshCartDrawer();
//   }

//   if (updatedCart.item_count === 0) {
//     const drawer = document.querySelector('cart-drawer');
//     const overlay = document.querySelector('.cart-drawer__overlay');
//     drawer?.classList.remove('is-open', 'active');
//     overlay?.classList.remove('is-visible', 'active');
//     document.body.classList.remove('overflow-hidden');
//   } else {
//     await refreshCartDrawer();
//   }

//   await syncCheckboxState(false);
// }

// // 🔁 REFRESH CART DRAWER SECTION
// // async function refreshCartDrawer() {
// //   try {
// //     const res = await fetch(window.location.pathname + '?sections=cart-drawer');
// //     if (!res.ok) return console.error('Failed to refresh cart drawer');

// //     const data = await res.json();
// //     const tempDiv = document.createElement('div');
// //     tempDiv.innerHTML = data['cart-drawer'];

// //     const newDrawerContent = tempDiv.querySelector('cart-drawer');
// //     const existingDrawer = document.querySelector('cart-drawer');
    
// //     if (existingDrawer && newDrawerContent) {
// //       existingDrawer.innerHTML = newDrawerContent.innerHTML;
// //     }

// //     // Rebind logic after drawer refresh
// //     initAddonCheckbox();
// //     bindOverlayClose();
// //     syncCheckboxState();
// //   } catch (err) {
// //     console.error('Error refreshing cart drawer:', err);
// //   }
// // }


// async function refreshCartDrawer() {
//   try {
//     // ✅ Remember current checkbox state
//     const checkbox = document.getElementById('addon-checkbox');
//     if (checkbox) lastCheckboxState = checkbox.checked;

//     const res = await fetch(window.location.pathname + '?sections=cart-drawer');
//     if (!res.ok) return console.error('Failed to refresh cart drawer');

//     const data = await res.json();
//     const tempDiv = document.createElement('div');
//     tempDiv.innerHTML = data['cart-drawer'];

//     const newDrawerContent = tempDiv.querySelector('cart-drawer');
//     const existingDrawer = document.querySelector('cart-drawer');
    
//     if (existingDrawer && newDrawerContent) {
//       existingDrawer.innerHTML = newDrawerContent.innerHTML;
//     }

//     // Rebind logic after drawer refresh
//     initAddonCheckbox();
//     bindOverlayClose();

//     // ✅ Instantly restore checkbox state after refresh (no flicker)
//     const newCheckbox = document.getElementById('addon-checkbox');
//     if (newCheckbox) newCheckbox.checked = lastCheckboxState;

//     // Double-check final state from cart data
//     syncCheckboxState();
//   } catch (err) {
//     console.error('Error refreshing cart drawer:', err);
//   }
// }


// // 🧩 INITIALIZE CHECKBOX LOGIC
// async function initAddonCheckbox() {
//   const checkbox = document.getElementById('addon-checkbox');
//   if (!checkbox) return;

//   const variantId = await getVariantIdByHandle(addonProductHandle);
//   const cart = await fetch('/cart.js').then(r => r.json());
//   const hasAddon = cart.items.some(i => i.variant_id === variantId);

//   // ✅ Rule 5: Match checkbox with cart state
//   checkbox.checked = hasAddon;

//   checkbox.addEventListener('change', async () => {
//     checkbox.disabled = true;
//     if (checkbox.checked) {
//       userOptedOut = false;
//       await addAddon(variantId);
//     } else {
//       userOptedOut = true;
//       await removeAddon(variantId);
//     }
//     checkbox.disabled = false;
//   });
// }

// // ✅ LIVE SYNC — keep checkbox state updated instantly
// // async function syncCheckboxState(forceChecked = null) {
// //   const checkbox = document.getElementById('addon-checkbox');
// //   if (!checkbox) return;

// //   if (forceChecked !== null) {
// //     checkbox.checked = forceChecked;
// //     return;
// //   }

// //   const variantId = await getVariantIdByHandle(addonProductHandle);
// //   const cart = await fetch('/cart.js').then(r => r.json());
// //   const hasAddon = cart.items.some(i => i.variant_id === variantId);

// //   checkbox.checked = hasAddon;
// // }


// async function syncCheckboxState(forceChecked = null) {
//   const checkbox = document.getElementById('addon-checkbox');
//   if (!checkbox) return;

//   if (forceChecked !== null) {
//     checkbox.checked = forceChecked;
//     lastCheckboxState = forceChecked; // ✅ Store latest user choice
//     return;
//   }

//   const variantId = await getVariantIdByHandle(addonProductHandle);
//   const cart = await fetch('/cart.js').then(r => r.json());
//   const hasAddon = cart.items.some(i => i.variant_id === variantId);

//   checkbox.checked = hasAddon;
//   lastCheckboxState = hasAddon; // ✅ Keep in sync
// }


// // 👁️ OBSERVE CART CHANGES — auto add when first product added
// async function observeCartChanges() {
//   const cartDrawer = document.querySelector('cart-drawer');
//   if (!cartDrawer) return;
//   const variantId = await getVariantIdByHandle(addonProductHandle);

//   const observer = new MutationObserver(async () => {
//     const cart = await fetch('/cart.js').then(r => r.json());
//     const hasAddon = cart.items.some(i => i.variant_id === variantId);

//     // 🧠 Rule 1 & 2 — Auto add when first product added
//     if (cart.items.length > 0 && !hasAddon && !userOptedOut) {
//       await addAddon(variantId);
//     }

//     // 🧹 Rule 4 — Remove if only add-on remains
//     if (cart.item_count === 1 && hasAddon) {
//       await removeAddon(variantId);
//     }

//     // ✅ Rule 5 — Keep checkbox in sync live
//     await syncCheckboxState();
//   });

//   observer.observe(cartDrawer, { childList: true, subtree: true });
// }

// // 🧱 FIX OVERLAY CLICK TO CLOSE CART DRAWER
// function bindOverlayClose() {
//   const overlay = document.querySelector('.cart-drawer__overlay');
//   const drawer = document.querySelector('cart-drawer');
//   if (overlay && drawer) {
//     overlay.addEventListener('click', () => {
//       drawer.classList.remove('is-open', 'active');
//       overlay.classList.remove('is-visible', 'active');
//       document.body.classList.remove('overflow-hidden');
//     });
//   }
// }

// // 🚀 INITIALIZE
// document.addEventListener('DOMContentLoaded', () => {
//   initAddonCheckbox();
//   observeCartChanges();
//   bindOverlayClose();
//   syncCheckboxState();
// });



// --- Shipping Protection Add-on (Fixed & Synced Version) --- //

const addonProductHandle = 'shipping-insurance'; // change this handle
let userOptedOut = false;
let isProcessing = false;

// 🧩 Get variant ID
async function getVariantIdByHandle(handle) {
  const res = await fetch(`/products/${handle}.js`);
  const product = await res.json();
  return product.variants[0].id;
}

// ➕ Add add-on product
async function addAddon(variantId) {
  if (isProcessing) return;
  isProcessing = true;

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });

  await refreshCartDrawer();
  isProcessing = false;
}

// ➖ Remove add-on product
async function removeAddon(variantId) {
  const cart = await fetch('/cart.js').then(r => r.json());
  const item = cart.items.find(i => i.variant_id === variantId);
  if (!item) return;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: item.key, quantity: 0 })
  });

  await refreshCartDrawer();
}

// 🔁 Refresh cart drawer section
async function refreshCartDrawer() {
  try {
    const res = await fetch(window.location.pathname + '?sections=cart-drawer');
    const data = await res.json();

    const newDrawer = document.createElement('div');
    newDrawer.innerHTML = data['cart-drawer'];

    const drawer = document.querySelector('cart-drawer');
    const newContent = newDrawer.querySelector('cart-drawer');
    if (drawer && newContent) drawer.innerHTML = newContent.innerHTML;

    initAddonCheckbox();
    bindOverlayClose();
    // syncCheckboxState();
  } catch (e) {
    console.error('Error refreshing cart:', e);
  }
}

async function syncCheckboxState(forceChecked = null) {
  const checkbox = document.getElementById('addon-checkbox');
  if (!checkbox) return;

  if (forceChecked !== null) {
    checkbox.checked = forceChecked;
    lastCheckboxState = forceChecked; // ✅ Store latest user choice
    return;
  }

  const variantId = await getVariantIdByHandle(addonProductHandle);
  const cart = await fetch('/cart.js').then(r => r.json());
  const hasAddon = cart.items.some(i => i.variant_id === variantId);

  checkbox.checked = hasAddon;
  lastCheckboxState = hasAddon; // ✅ Keep in sync
}


// 🧩 Checkbox logic
async function initAddonCheckbox() {
  const checkbox = document.getElementById('addon-checkbox');
  if (!checkbox) return;

  const variantId = await getVariantIdByHandle(addonProductHandle);
  const cart = await fetch('/cart.js').then(r => r.json());
  const hasAddon = cart.items.some(i => i.variant_id === variantId);

  // Match checkbox with cart state
  checkbox.checked = hasAddon;

  checkbox.addEventListener('change', async () => {
    checkbox.disabled = true;
    if (checkbox.checked) {
      userOptedOut = false;
      await addAddon(variantId);
    } else {
      userOptedOut = true;
      await removeAddon(variantId);
    }
    checkbox.disabled = false;
  });
}

// 🧠 Watch cart for product additions
async function observeCart() {
  const variantId = await getVariantIdByHandle(addonProductHandle);

  const observer = new MutationObserver(async () => {
    if (isProcessing) return;
    const cart = await fetch('/cart.js').then(r => r.json());
    const hasAddon = cart.items.some(i => i.variant_id === variantId);

    // Auto-add when first product added
    if (cart.items.length > 0 && !hasAddon && !userOptedOut) {
      await addAddon(variantId);
    }

    // Auto-remove if only add-on remains
    if (cart.item_count === 1 && hasAddon) {
      await removeAddon(variantId);
    }

    // Keep checkbox synced
    const checkbox = document.getElementById('addon-checkbox');
    if (checkbox) checkbox.checked = hasAddon;

    //  syncCheckboxState();
  });

  const drawer = document.querySelector('cart-drawer');
  if (drawer) observer.observe(drawer, { childList: true, subtree: true });
}

// 🧱 Fix overlay click to close drawer
function bindOverlayClose() {
  const overlay = document.querySelector('.cart-drawer__overlay');
  const drawer = document.querySelector('cart-drawer');
  if (!overlay || !drawer) return;

  overlay.addEventListener('click', () => {
    drawer.classList.remove('is-open', 'active');
    overlay.classList.remove('is-visible', 'active');
    document.body.classList.remove('overflow-hidden');
  });
}

// 🚀 Initialize everything
document.addEventListener('DOMContentLoaded', () => {
  
  // syncCheckboxState();
  window.subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      setTimeout(function() {
        initAddonCheckbox();
        observeCart();
        bindOverlayClose();
      },800);
    });
  initAddonCheckbox();
  observeCart();
  bindOverlayClose();
});
